export enum AppMessageType {
  //informar que botão pesquisar foi clicado.
  PESQUISAR = 1,
  BREADCRUMB = 2,
  CHILD_MESSAGE = 3,
  LOGIN = 3 //login realizado com sucesso
}
